import { SalaryAnalysis } from '@lib/utils';

import { HighSchoolSalary } from '../models/high-school-salary.model';

export const convertHighSchoolSalaryToSalaryAnalysis = (
  data: HighSchoolSalary,
  locationName: string
): SalaryAnalysis => {
  return {
    geographyName: locationName,
    minimumAnnualSalary: data.avgAPct25,
    medianAnnualSalary: data.avgAPct25
  };
};
